/* eslint-disable */
import * as Types from '../../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SubscribeToQuoteTemplateMutationVariables = Types.Exact<{
  input: Types.SubscribeToQuoteTemplateInput;
}>;


export type SubscribeToQuoteTemplateMutation = { subscribeToQuoteTemplate: { __typename: 'SubscribeToQuoteTemplateResult', quoteTemplate: { __typename: 'QuoteTemplate', id: string, resolvedAsReadModelVersionNumber?: number | null, latestPublishedVersionNumber?: number | null, templateSharing?: { __typename: 'TemplateSharing', id: string, latestSharedVersionNumber: number, sharedPublicly: boolean, subscribedToTemplate?: { __typename: 'TemplateSubscription', subscribedVersionNumber: number, updateAvailable: boolean } | null } | null } } };

export type QuoteTemplateSubscribeButton_QuoteTemplateFragment = { __typename: 'QuoteTemplate', id: string, latestPublishedVersionNumber?: number | null, templateSharing?: { __typename: 'TemplateSharing', id: string, latestSharedVersionNumber: number, sharedPublicly: boolean, subscribedToTemplate?: { __typename: 'TemplateSubscription', subscribedVersionNumber: number, updateAvailable: boolean } | null } | null };

export type SubscribeToQuoteTemplate_HasOverridesQueryVariables = Types.Exact<{
  templateId: Types.Scalars['ID']['input'];
}>;


export type SubscribeToQuoteTemplate_HasOverridesQuery = { quoteTemplateHasOverrides: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'QuoteTemplateHasOverridesResult', version?: number | null } };

export const QuoteTemplateSubscribeButton_QuoteTemplateFragmentDoc = gql`
    fragment QuoteTemplateSubscribeButton_QuoteTemplate on QuoteTemplate {
  id
  latestPublishedVersionNumber
  templateSharing {
    id
    latestSharedVersionNumber
    sharedPublicly
    subscribedToTemplate {
      subscribedVersionNumber
      updateAvailable
    }
  }
}
    `;
export const SubscribeToQuoteTemplateDocument = gql`
    mutation SubscribeToQuoteTemplate($input: SubscribeToQuoteTemplateInput!) {
  subscribeToQuoteTemplate(input: $input) {
    quoteTemplate {
      id
      resolvedAsReadModelVersionNumber
      ...QuoteTemplateSubscribeButton_QuoteTemplate
    }
  }
}
    ${QuoteTemplateSubscribeButton_QuoteTemplateFragmentDoc}`;
export type SubscribeToQuoteTemplateMutationFn = Apollo.MutationFunction<SubscribeToQuoteTemplateMutation, SubscribeToQuoteTemplateMutationVariables>;

/**
 * __useSubscribeToQuoteTemplateMutation__
 *
 * To run a mutation, you first call `useSubscribeToQuoteTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToQuoteTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscribeToQuoteTemplateMutation, { data, loading, error }] = useSubscribeToQuoteTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubscribeToQuoteTemplateMutation(baseOptions?: Apollo.MutationHookOptions<SubscribeToQuoteTemplateMutation, SubscribeToQuoteTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubscribeToQuoteTemplateMutation, SubscribeToQuoteTemplateMutationVariables>(SubscribeToQuoteTemplateDocument, options);
      }
export type SubscribeToQuoteTemplateMutationHookResult = ReturnType<typeof useSubscribeToQuoteTemplateMutation>;
export type SubscribeToQuoteTemplateMutationResult = Apollo.MutationResult<SubscribeToQuoteTemplateMutation>;
export type SubscribeToQuoteTemplateMutationOptions = Apollo.BaseMutationOptions<SubscribeToQuoteTemplateMutation, SubscribeToQuoteTemplateMutationVariables>;
export const SubscribeToQuoteTemplate_HasOverridesDocument = gql`
    query SubscribeToQuoteTemplate_HasOverrides($templateId: ID!) {
  quoteTemplateHasOverrides(id: $templateId) {
    ... on QuoteTemplateHasOverridesResult {
      version
    }
  }
}
    `;

/**
 * __useSubscribeToQuoteTemplate_HasOverridesQuery__
 *
 * To run a query within a React component, call `useSubscribeToQuoteTemplate_HasOverridesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToQuoteTemplate_HasOverridesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeToQuoteTemplate_HasOverridesQuery({
 *   variables: {
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useSubscribeToQuoteTemplate_HasOverridesQuery(baseOptions: Apollo.QueryHookOptions<SubscribeToQuoteTemplate_HasOverridesQuery, SubscribeToQuoteTemplate_HasOverridesQueryVariables> & ({ variables: SubscribeToQuoteTemplate_HasOverridesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubscribeToQuoteTemplate_HasOverridesQuery, SubscribeToQuoteTemplate_HasOverridesQueryVariables>(SubscribeToQuoteTemplate_HasOverridesDocument, options);
      }
export function useSubscribeToQuoteTemplate_HasOverridesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubscribeToQuoteTemplate_HasOverridesQuery, SubscribeToQuoteTemplate_HasOverridesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubscribeToQuoteTemplate_HasOverridesQuery, SubscribeToQuoteTemplate_HasOverridesQueryVariables>(SubscribeToQuoteTemplate_HasOverridesDocument, options);
        }
export function useSubscribeToQuoteTemplate_HasOverridesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubscribeToQuoteTemplate_HasOverridesQuery, SubscribeToQuoteTemplate_HasOverridesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubscribeToQuoteTemplate_HasOverridesQuery, SubscribeToQuoteTemplate_HasOverridesQueryVariables>(SubscribeToQuoteTemplate_HasOverridesDocument, options);
        }
export type SubscribeToQuoteTemplate_HasOverridesQueryHookResult = ReturnType<typeof useSubscribeToQuoteTemplate_HasOverridesQuery>;
export type SubscribeToQuoteTemplate_HasOverridesLazyQueryHookResult = ReturnType<typeof useSubscribeToQuoteTemplate_HasOverridesLazyQuery>;
export type SubscribeToQuoteTemplate_HasOverridesSuspenseQueryHookResult = ReturnType<typeof useSubscribeToQuoteTemplate_HasOverridesSuspenseQuery>;
export type SubscribeToQuoteTemplate_HasOverridesQueryResult = Apollo.QueryResult<SubscribeToQuoteTemplate_HasOverridesQuery, SubscribeToQuoteTemplate_HasOverridesQueryVariables>;